import { ChatProviderIdEnum, EmailProviderIdEnum, InAppProviderIdEnum, SmsProviderIdEnum, } from '../../types';
import { chatProviders, emailProviders, inAppProviders, pushProviders, smsProviders } from './channels';
export { chatProviders, emailProviders, inAppProviders, pushProviders, smsProviders } from './channels';
export const providers = [
    ...emailProviders,
    ...smsProviders,
    ...chatProviders,
    ...pushProviders,
    ...inAppProviders,
];
export const NOVU_PROVIDERS = [
    InAppProviderIdEnum.Novu,
    SmsProviderIdEnum.Novu,
    EmailProviderIdEnum.Novu,
    ChatProviderIdEnum.Novu,
];
export const NOVU_SMS_EMAIL_PROVIDERS = [SmsProviderIdEnum.Novu, EmailProviderIdEnum.Novu];
export const PROVIDER_ID_TO_CHANNEL_MAP = Object.fromEntries(providers.map((p) => [p.id, p.channel]));
//# sourceMappingURL=providers.js.map